<template>
  <editable-box
    ref="editableBox"
    :mode="mode"
    :includeBtns="['drag', 'setup', 'delete', 'add']"
    @onSetup="handleSetup"
    @onAdd="handelAdd"
    @onDelete="handelDelete"
  >
    <template slot-scope="scope">
      <div class="info-box" :class="{ 'is-horizontal': data.isHorizontal }">
        <div class="title" v-if="!data.isHideTitle">
          <text-box
            type="editor"
            position="rightTop"
            :mode="mode"
            :image-style="{ height: '22px' }"
            :value="data.title"
            @onChange="handleTitleChange"
          >
            {{ data.title || "标题" }}
          </text-box>
        </div>
        <div class="content" v-if="!data.isHideContent">
          <text-box
            type="editor"
            position="rightTop"
            :mode="mode"
            :image-style="{ height: data.isHorizontal ? '72px' : '22px' }"
            :value="data.content"
            @onChange="handleContentChange"
          >
            {{ data.content || "内容" }}
          </text-box>
        </div>
        <!-- 设置 -->
        <setup-panel
          v-if="mode === 'edit'"
          ref="setupPannel"
          :data="data"
          @onChange="handleSetupPannelChange"
        ></setup-panel>
      </div>
    </template>
  </editable-box>
</template>

<script>
import EditableBox from "../../../../components/EditableBox/index.jsx";
import TextBox from "../../../../components/TextBox";
import SetupPanel from "./SetupPanel.vue";

export default {
  name: "InfoBox",
  components: {
    EditableBox,
    TextBox,
    SetupPanel
  },
  props: {
    mode: String,
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {};
  },
  computed: {
    isEditorValue() {
      return (
        this.data &&
        typeof this.data.content !== "string" &&
        this.data.content.type &&
        this.data.content.type === "simpleEditor"
      );
    }
  },

  mounted() {},

  methods: {
    handleSetup() {
      this.$refs.setupPannel.open();
    },
    handelAdd() {
      this.$emit("onAdd");
    },
    handelDelete() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      this.$emit("onChange", {
        ...this.data,
        title
      });
    },
    handleContentChange(content) {
      this.$emit("onChange", {
        ...this.data,
        content
      });
    },
    handleSetupPannelChange(data) {
      this.$emit("onChange", {
        ...this.data,
        ...data
      });
    }
  }
};
</script>

<style lang="less" scoped>
.info-box {
  display: flex;
  flex-direction: column;
  min-width: 87px;
  min-height: 22px;
  background: rgba(122, 147, 172, 0.12);
  border-radius: 8px;
  padding: 6px 15px;
  gap: 14px;
  &.is-horizontal {
    flex-direction: row;
    align-items: center;

    .title {
      flex: 1;
      max-width: 150px;
      margin-bottom: 0;
    }
    .content {
      min-width: 150px;
      line-height: 22px;
      text-align: left;
    }
  }
  .title {
    width: 100%;
    height: 22px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #373737;
    line-height: 22px;
  }
  .content {
    min-width: 75px;
    font-size: 14px;
    font-weight: 400;
    color: #373737;
    line-height: 22px;
    text-align: center;
  }
}
</style>
